<template>
  <q-card class="email-templates" style="height: 700px">
    <q-card-section class="row justify-between items-center bg-primary text-white q-py-sm">
      <div class="text-subtitle1">Email templates</div>
      <q-btn color="tertiary" size="sm" @click="addNewTemplate">Add new template</q-btn>
    </q-card-section>

    <q-card-section class="area-wrapper">
      <q-scroll-area style="height: 100%; max-width: 300px; border-right: 2px solid #bdbdbd">
        <q-list :bordered="false" class="no-border">
          <q-item
            v-for="(template, index) of dataEmailTemplates.email_templates"
            :key="template.id"
            :active="selectedTemplateIndex === index"
            active-class="selected"
            class="template"
            clickable
            @click="selectedTemplateIndex = index"
          >
            <q-item-section>
              {{ template.name || 'N/A' }}
              <template v-if="template.default">(default)</template>
            </q-item-section>
          </q-item>
        </q-list>
      </q-scroll-area>

      <q-scroll-area style="height: 100%;">
        <div class="toolbar flex justify-between items-center q-py-sm q-px-md">
          <div class="title text-uppercase">
            {{ dataEmailTemplates.email_templates[selectedTemplateIndex].name || 'N/A' }}

            <span v-if="dataEmailTemplates.email_templates[selectedTemplateIndex].default" class="text-dark">
              (default)
            </span>

            <q-icon
              name="edit"
              size="1.2rem"
              color="tertiary"
              class="q-ml-sm cursor-pointer"
              @click="editName(selectedTemplateIndex)"
            />
          </div>

          <div class="actions">
            <q-btn
              v-if="!dataEmailTemplates.email_templates[selectedTemplateIndex].default"
              size="sm"
              class="on-left"
              color="tertiary"
              @click="$emit('set-default', selectedTemplateIndex)"
            >
              Set as default
            </q-btn>

            <span>
              <q-btn
                v-if="dataEmailTemplates.email_templates.length > 1"
                :disable="dataEmailTemplates.email_templates[selectedTemplateIndex].default"
                size="sm"
                color="negative"
                @click="deleteTemplate(selectedTemplateIndex)"
              >
                Remove
              </q-btn>
              <LmTooltip v-if="dataEmailTemplates.email_templates[selectedTemplateIndex].default">
                You cannot delete a default template. Choose another default first.
              </LmTooltip>
            </span>
          </div>
        </div>

        <div class="col-xs-12">
          <transition
            :duration="200"
            appear
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            mode="out-in"
            style="width: 100%"
          >
            <q-card :key="dataEmailTemplates.email_templates[selectedTemplateIndex].name" flat>
              <q-card-section class="q-py-xs">
                <EmailEditor
                  :model-subject="dataEmailTemplates.email_templates[selectedTemplateIndex].subject"
                  :model-content="dataEmailTemplates.email_templates[selectedTemplateIndex].body"
                  :merge-tags="dataEmailTemplates.merge_tags"
                  @content-input="updateEmailContent"
                  @subject-input="updateEmailSubject"
                />
              </q-card-section>
            </q-card>
          </transition>
        </div>
      </q-scroll-area>
    </q-card-section>
  </q-card>
</template>

<script>
// Components
import EmailEditor from '@components/editors/EmailEditor'

export default {
  components: { EmailEditor },

  props: {
    dataEmailTemplates: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    selectedTemplateIndex: 0
  }),

  methods: {
    addNewTemplate() {
      this.$q
        .dialog({
          title: 'Name of the template',
          prompt: {
            model: '',
            type: 'text',
            label: 'Name',
            outlined: true,
            isValid: val => !!val.trim()
          },
          cancel: true,
          persistent: true
        })
        .onOk(data => {
          this.$emit('new-template', data.trim())
          this.selectedTemplateIndex = this.dataEmailTemplates.email_templates.length - 1
        })
    },

    updateEmailContent(newContent) {
      this.dataEmailTemplates.email_templates[this.selectedTemplateIndex].body = newContent
    },

    updateEmailSubject(newSubject) {
      this.dataEmailTemplates.email_templates[this.selectedTemplateIndex].subject = newSubject
    },

    deleteTemplate(templateIndex) {
      if (templateIndex === this.dataEmailTemplates.email_templates.length - 1) {
        this.selectedTemplateIndex = this.dataEmailTemplates.email_templates.length - 2
      }

      this.$emit('delete-template', templateIndex)
    },

    editName(templateIndex) {
      this.$q
        .dialog({
          title: 'Update the name of the template',
          prompt: {
            model: this.dataEmailTemplates.email_templates[templateIndex].name || '',
            type: 'text',
            label: 'Name',
            outlined: true,
            isValid: val => !!val.trim()
          },
          cancel: true,
          persistent: true
        })
        .onOk(data => {
          this.$emit('update-name', { index: templateIndex, newName: data.trim() })
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.email-templates {
  display grid
  grid-template-rows auto 1fr

  .area-wrapper {
    display grid
    grid-template-columns 300px 1fr
  }

  .template {
    cursor pointer
    &:hover {
      background: $lighter-grey
    }
    &.selected {
      background $primary
      color white
      &:hover {
        background: $lighter-grey
        color: $primary
      }
    }
  }

}
</style>
